import React from 'react';
import { Form, Input, Button,Select,message,Spin,Result,Card } from 'antd';
import { Table,Collapse,Popover,Popconfirm,Descriptions,Modal } from 'antd';
import axios from 'axios'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import * as serverconfig from '../../views/serverconn'
import moment from 'moment';

import { SearchOutlined,LoadingOutlined,DeleteOutlined,FundViewOutlined,WalletFilled,EditOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");

const dateFormattn = 'HHmmssDDMMYYYY';
const dateFormat = 'DD/MM/YYYY';

const FormItem=Form.Item;
const { Option } = Select;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
var sacco=''


class SMSPaymentForm extends React.Component {

  state = {
    reason:'',  
    licence:'',
    remark:'',
    companylogo:null,   
    companyphone:'',
    amount:0,
    accountslimit:0,
    branchname:'',
    website:'',
    address:'',
    datarequested:true,  
    safebalance:0,
    sharevalue:0,
    retainedearnings:0,
    packages:[],
    package:'',
    apicode:'',
    smsclients:[],
    datasubmittedsuccessfully:false,
    message:'',
    companyprofile:{}

  }


  componentDidMount(){
    if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }

   if(localStorage.getItem("sacco")){
    sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
 
 }else{
    sacco= ''
    username=''
 }
 

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

        this.setState({datarequested:false})

    })


}

  ////////////////////////////////////
  // PRODUCT SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }



  //submit button pressed
  handleFormSubmit=async(event) =>{
      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }


      if(this.state.amount===0 || this.state.amount<500){
        message.error("Amount cant be zero or less than 500 shs")
      }else if(this.state.companyphone===''){
        message.error("Phone number cant be empty")
      }else if (this.state.companyprofile.smsgatewaycode==="null" || this.state.companyprofile.smsgatewaycode==="")
      message.error("SMS gateway missing ")
  
      else{
  
        this.setState({datarequested:true})
  
        let form_data = new FormData();
        form_data.append('reason', "sms purchase");
        form_data.append('remark', "sms purchase remarks");
        form_data.append('phone', this.state.companyphone);
        form_data.append('amount', this.state.amount);
        form_data.append('requestfrom', "smsdashboard");
        form_data.append('transactionId', "TXN"+moment().format(dateFormattn).toString());
        form_data.append('date', moment().format(dateFormat).toString());
        form_data.append('apicode', this.state.companyprofile.smsgatewaycode);
    
        axios.post('https://3-be-newpitechsms-gatewaybackend.pitech.co.ug/customqueries/makeclientsmspayment', form_data, {
          headers: {
            'content-type': 'multipart/form-data'
          }
        })
      .then(res =>{
        this.setState({datarequested:false})
        this.setState({reason:''})
        this.setState({remark:''})
        this.setState({companyphone:''})
        this.setState({amount:0})
    
        this.setState({message:res.data.message})
        this.setState({datasubmittedsuccessfully:true})
    
       } 
      )
      .catch(error => console.log(error))
      }


  }

  handlereasonChange= (e) => this.setState({ reason: e.target.value});
  handleremarkChange= (e) => this.setState({ remark: e.target.value});
  handleCompanyPhoneChange= (e) => this.setState({ companyphone: e});
  handleCompanyamountChange= (e) => this.setState({ amount: e.target.value});
  handleclientChange= (e) => this.setState({ apicode: e});

  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
    }else{

      if (this.state.datasubmittedsuccessfully===true){
        return(
            <Card>
            <Result
            status="success"
            title={this.state.message}
            extra={[
              <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
            ]}
            />
            </Card>
        );

      }else{

        return (
          <div >
            <h3>SMS payment via mobile money</h3>
            <Form
            onFinish={(event) => this.handleFormSubmit(event)}
            >

              <FormItem label="Phone Number">
              <PhoneInput
                    countrySelectProps={{ unicodeFlags: true }}
                    defaultCountry="UG"
                    placeholder="Enter phone number"
                    value={this.state.companyphone} onChange={this.handleCompanyPhoneChange}/>
               </FormItem>
  
               
              <FormItem label="Amount">
                <Input name="amount" type='number'  placeholder="Amount here" value={this.state.amount} onChange={this.handleCompanyamountChange} />
              </FormItem>
  

              <FormItem>
                <Button type="primary" htmlType="submit" >Submit</Button>
              </FormItem>
            </Form>
          </div>
        );


      }


    }
  }

}


export default SMSPaymentForm;



